import React, {useEffect, useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {Container, Typography, Box, Alert} from '@mui/material';
import AuthForm from '../components/AuthForm';
import {login, isAuthenticated} from '../services/auth';
import {Image} from "@mui/icons-material";

const Login: React.FC = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean | null>(null);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (isAuthenticated()) {
            navigate('/');
        }
    }, [navigate]);

    const handleLogin = async (data: { username: string; password: string }) => {
        try {
            setLoading(true)
            await login(data.username, data.password);
            setLoading(false)
            navigate('/dashboard');
        } catch (error: any) {
            setError(error.response.data.detail)
            setLoading(false)
            console.error('Login failed:', error);
        }
    };

    return (
        <Box sx={{display: 'flex', height: '100vh'}}>
            {/* Левая часть с фоновым изображением */}
            <Box
                sx={{
                    margin: '4px',
                    borderRadius: '12px',
                    flex: 1,
                    backgroundImage: 'url(https://static.productscript.ru/uploads/images/pattern.jpg)',
                    backgroundSize: 'cover'
                }}
            />
            <Container component="main" maxWidth="xs">
                <Box sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    height: '100vh'
                }}>
                    <Box sx={{mt: 6}}>
                        <img src="/logo.svg" className='startLogo' alt=""/>
                    </Box>
                    <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                        <Typography component="h1" variant="h5">
                            Авторизация
                        </Typography>

                        <AuthForm onSubmit={handleLogin} buttonText="Войти" loading={loading} error={error}/>
                        {error && <Alert severity="error"
                                         sx={{width: "100%", boxSizing: 'border-box', mt: 1}}>{error}</Alert>}
                        <Box sx={{mt: 3, display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                            <Link to="/forgot-password">Забыли пароль?</Link>
                            <Link to="/register">Зарегистрироваться</Link>
                        </Box>
                    </Box>
                    <Box sx={{
                        mb: 4,
                        mt: 5,
                        display: 'block',
                        justifyContent: 'space-between',
                        width: '100%',
                        textAlign: 'center',
                        color: '#888'
                    }}>
                        2024
                    </Box>

                </Box>
            </Container>
        </Box>
    );
};

export default Login;
